// @flow

import React from 'react';
import { connect } from 'react-redux';
import { Cookies, withCookies } from 'react-cookie';
import { currenciesSymbols, twCurrency, twSurfaceUnit } from '../../const';
import { storeIsCurrencyBySurface } from '../../state/stores/storeService';

type Props = {
  cookies: Cookies,
  isCurrencyBySurface: boolean,
  dispatch: () => void,
  displaySelector: ?boolean,
}

class CurrencySurfaceSwitcher extends React.PureComponent<Props> {
  static defaultProps = {
    quantity: '',
    gla: 1,
  };
  symbols = {
    m: {
      symbol: 'm²',
    },
    ft: {
      symbol: 'ft²',
    },
  };

  render() {
    return (
      <div className="selector-buttons-row">
        {
          this.props.displaySelector ?
            <React.Fragment>
              <button
                onClick={() => this.props.dispatch(storeIsCurrencyBySurface(false))}
                className={`selector-buttons ${!this.props.isCurrencyBySurface ? 'selected' : ''}`}
              >
                {currenciesSymbols[this.props.cookies.get(twCurrency)] ||
                this.props.cookies.get(twCurrency)}
              </button>
              <button
                onClick={() => this.props.dispatch(storeIsCurrencyBySurface(true))}
                className={`selector-buttons ${this.props.isCurrencyBySurface ? 'selected' : ''}`}
              >
                {`${currenciesSymbols[this.props.cookies.get(twCurrency)] || this.props.cookies.get(twCurrency)}/${this.symbols[this.props.cookies.get(twSurfaceUnit)] && this.symbols[this.props.cookies.get(twSurfaceUnit)].symbol}`}
              </button>
            </React.Fragment> :
            <div
              className="selector-buttons selected"
            >
              {`${currenciesSymbols[this.props.cookies.get(twCurrency)] || this.props.cookies.get(twCurrency)} ${this.props.isCurrencyBySurface ? `/${this.symbols[this.props.cookies.get(twSurfaceUnit)].symbol}` : ''}`}
            </div>
        }

      </div>
    );
  }
}

export default withCookies(connect(state => ({
  isCurrencyBySurface: state.store.isCurrencyBySurface,
}))(CurrencySurfaceSwitcher));
